
import { Component, Vue, Prop } from 'vue-property-decorator';

import { TransactionsSummaryList } from '@/modules/transaction/components/TransactionsSummaryList';
import {
  TradeOrder,
  ETradeMovementType
} from '@/modules/common/services/graphql/server/server.sdk';
import { InstrumentPositions } from './components/InstrumentPositions';

import { getTrasactionDate } from '@/modules/common/helpers/date';
import { ITransactionSummary } from '@/types/models';

import {
  trackOrderClick,
  trackViewAllOrdersClick
} from '@/modules/trade/views/Instrument/trackers';
import { TradeInstrumentPositionPrice } from '@/modules/trade/types/instrument';
import { Feature } from '@/modules/common/components/Feature';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { InstrumentAllocation } from './components/InstrumentAllocation';
import { CustomOperationsSection } from './components/CustomOperationsSection';
import { OrdersSection } from './components/OrdersSection';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

@Component({
  components: {
    CustomOperationsSection,
    TransactionsSummaryList,
    InstrumentPositions,
    Feature,
    InstrumentAllocation,
    OrdersSection
  }
})
export default class InstrumentDetails extends Vue {
  @Prop({ type: Object })
  readonly position!: TradeInstrumentPositionPrice;

  @Prop({ type: Array, default: () => [] })
  readonly orders!: TradeOrder[];

  get isCustomOperationsListEnabled() {
    return FeatureFlagsModule.isEnabled(
      FeatureFlags.ENABLE_CUSTOM_OPERATIONS_LIST
    );
  }

  get isIntegrationWithFinOneV0Enabled() {
    return FeatureFlagsModule.isEnabled(
      FeatureFlags.ENABLE_FIN_ONE_INTEGRATION_WITH_TRADE_V0
    );
  }

  get FeatureFlags() {
    return FeatureFlags;
  }

  get parsedOrders() {
    if (!this.orders) return [];
    return this.orders.map(order => {
      return {
        ...order,
        // @ts-ignore
        date: getTrasactionDate(order.date, false),
        type: {
          value: this.getTypeOrder(order!.movementType!.value as string),
          formatted: order.type.formatted
        }
      };
    });
  }

  handleOrderClick(order: ITransactionSummary) {
    trackOrderClick(order.description!);
  }

  handleRedirectToTransactions() {
    trackViewAllOrdersClick();
  }

  private getTypeOrder(type: string) {
    if (type === ETradeMovementType.AssetTransfer) {
      return 'asset_transfer';
    } else if (type === ETradeMovementType.Order) {
      return 'order';
    } else {
      return '';
    }
  }
}
